export { applyDiscountToValue } from './lib/discounts-utils-products'
